module.exports = __webpack_public_path__ + "img/hongxin.12f62a9d.png";